import createReducer from "./createReducer";
import * as types from "../constants/ActionTypes";
import { Reducer } from "redux";
import { ActionPayload, ID } from "../../types";
import { HiddenPayload } from "../actions/hiddenActions";

export type HiddenState = ID[];
type HiddenReducer<T> = Reducer<HiddenState, ActionPayload<T>>;

const addHidden: HiddenReducer<HiddenPayload> = (state, action) => {
  if (!state) return [];
  const { payload } = action;
  const { id } = payload;
  if (!state.includes(id)) return [...state, id];
  return state;
};

const removeHidden: HiddenReducer<HiddenPayload> = (state, action) => {
  if (!state) return [];
  const { payload } = action;
  const { id } = payload;
  const filtered = state.filter((el) => el !== id);
  return [...filtered];
};

const hiddenReducer = createReducer<HiddenState>([], {
  [types.ADD_HIDDEN]: addHidden,
  [types.REMOVE_HIDDEN]: removeHidden,
});
export default hiddenReducer;
